let url = "";
let preffix = "";
let preffixFile = "";
let local = "";
let localone = "";
if (process.env.NODE_ENV === "production") {
  if (process.env.type === "testing") {
    url = "http://47.99.223.83:1966/platform_manager";
    preffix = "https://bxzgtest.oss-cn-hangzhou.aliyuncs.com/img/";
    preffixFile = "https://bxzgtest.oss-cn-hangzhou.aliyuncs.com/file/"; //文件预览
  } else {
    url = "https://cms.bxzg.cn/platform_manager";
    preffix = "https://bxzg.oss-cn-hangzhou.aliyuncs.com/img/"; //图片预览
    preffixFile = "https://bxzg.oss-cn-hangzhou.aliyuncs.com/file/"; //文件预览
  }
} else {
  url = "https://jl.mmzxb.net/platform_manager";
  preffix = "https://bxzgtest.oss-cn-hangzhou.aliyuncs.com/img/"; //图片预览
  preffixFile = "https://bxzgtest.oss-cn-hangzhou.aliyuncs.com/file/"; //文件预览
  // dev 走 webpack 代理（/manager -> http://localhost:8081），避免跨域
  url = "/manager";
  // local = "http://192.168.1.115:8081/manager";
  // local = "http://192.168.1.110:8081/manager";
  local = "http://192.168.5.250:8081/manager";
  // local = "http://192.168.5.105:8080/manager"; //棒棒地址

  localone = "http://192.168.5.105:8080/manager";
  // url="http://192.168.1.133:8086/manager"
  // url="http://192.168.0.13/manager"
  // url="http://192.168.0.12:8080/manager"
  // url="http://192.168.0.12:8080/manager"
}
export { url, local, preffix, preffixFile, localone };



// WEBPACK FOOTER //
// ./src/components/common/common.js